import React from 'react';
import { IonButton } from '@ionic/react';
import { WhatsAppWebIssue, WhatsAppWebStage } from './WhatsAppWebConnection';

type Props = {
  stage: WhatsAppWebStage;
  issue: WhatsAppWebIssue | null;
  qrCodeData?: string;
  onConnect: () => void;
  onRetry: () => void;
  onClose: () => void;
};

const messages: Record<WhatsAppWebStage, string> = {
  checking: 'Verificando a conexão com o WhatsApp...',
  starting: 'Preparando o WhatsApp Web. Aguarde...',
  ready: 'Quando estiver pronto, toque em Conectar WhatsApp para exibir o QR Code.',
  preparing: 'Preparando o QR Code. Aguarde...',
  qr: 'Leia o QR Code no celular para conectar.',
};

export function WhatsAppWebConnectionFeedback({ stage, issue, qrCodeData, onConnect, onRetry, onClose }: Props) {
  if (issue) return <>
    <p role="alert">{issue.message}</p>
    <IonButton onClick={issue.action === 'refresh' ? onConnect : issue.action === 'close' ? onClose : onRetry}>
      {issue.action === 'refresh' ? 'Atualizar QR Code' : issue.action === 'close' ? 'Fechar' : 'Tentar novamente'}
    </IonButton>
  </>;

  return <>
    {qrCodeData && <img src={qrCodeData} alt="QR Code para conectar o WhatsApp" />}
    <p role="status">{messages[stage]}</p>
    {['checking', 'starting', 'ready'].includes(stage) &&
      <IonButton disabled={stage !== 'ready'} onClick={onConnect}>Conectar WhatsApp</IonButton>}
  </>;
}
